const trustItems = [
  {
    icon: 'ri-building-2-line',
    value: '15+',
    label: 'Years in Commercial Construction',
  },
  {
    icon: 'ri-shield-check-line',
    value: 'Licensed',
    label: 'Georgia General Contractor',
  },
  {
    icon: 'ri-star-fill',
    value: '5.0★',
    label: 'Google Rating — 40+ Reviews',
  },
  {
    icon: 'ri-map-pin-2-line',
    value: 'Henry County',
    label: 'Locally Owned & Operated',
  },
  {
    icon: 'ri-tools-line',
    value: '500+',
    label: 'Commercial Projects Completed',
  },
];

export default function TrustBar() {
  return (
    <section className="bg-stone-950 py-10 border-b border-stone-800">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-6 md:gap-0">
          {trustItems.map((item, i) => (
            <div
              key={item.label}
              className={`flex flex-col items-center text-center px-4 py-2 ${
                i < trustItems.length - 1 ? 'md:border-r md:border-stone-700' : ''
              }`}
            >
              <span className="w-8 h-8 flex items-center justify-center mb-2">
                <i className={`${item.icon} text-amber-500 text-xl`} />
              </span>
              <span
                className="text-white font-bold text-lg leading-tight"
                style={{ fontFamily: "'Playfair Display', serif" }}
              >
                {item.value}
              </span>
              <span className="text-stone-400 text-xs mt-1 leading-snug">{item.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
